// Single source of truth for brand info
export const BRAND = {
  name: "Swift Financial Solutions",
  short: "Swift Financial",
  tagline: "From Dream to Deed — We Walk Every Step With You",
  founded: "March 2018",
  founderName: "Rajasekhar Kasunur",
  founderTitle: "Founder · Partner in Growth",
  // Primary portrait — used as circular avatar and small photo spots
  founderPhoto:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_rapid-finance-8/artifacts/94d738e6663e57cd_WhatsApp%20Image%202026-05-02%20at%2021.22.32.jpeg",
  // Alt portraits for editorial / full-chest-up placements
  founderPhotos: {
    square:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_rapid-finance-8/artifacts/94d738e6663e57cd_WhatsApp%20Image%202026-05-02%20at%2021.22.32.jpeg",
    editorial:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_rapid-finance-8/artifacts/263d29f2e985352b_WhatsApp%20Image%202026-05-02%20at%2021.22.32%20%281%29.jpeg",
    warm:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_rapid-finance-8/artifacts/01c6aab0e38c294c_WhatsApp%20Image%202026-05-02%20at%2021.22.31.jpeg",
  },
  email: "swiftsolutionsraj@gmail.com",
  emailLegacy: "Raj@swiftsolutions2018.com",
  phone: "9535896633",
  phoneE164: "+919535896633",
  whatsapp: "919535896633",
  linkedin: "https://www.linkedin.com/in/rajasekhar-kasunur-228088376",
  city: "Bangalore",
  memoryHook:
    "Need a loan? Talk to Raj at Swift Financial — Your Partners in Growth",
};

export const STATS = [
  { value: "15+", label: "Lender Partners" },
  { value: "₹25L", label: "Min Ticket Size" },
  { value: "48hr", label: "Approvals*" },
  { value: "2018", label: "Trusted Since" },
];

export const SERVICES = [
  {
    id: "home_loan",
    title: "Home Loans",
    icon: "Home",
    blurb:
      "Buy, build or transfer — get the right home-loan partner without the paperwork chase.",
    items: ["Purchase", "Construction", "Balance Transfer"],
    image:
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "business_loan",
    title: "Business Loans",
    icon: "Briefcase",
    blurb:
      "Working capital, term loans and MSME funding — structured for cash-flow comfort.",
    items: ["Working Capital", "Term Loans", "MSME"],
    image:
      "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "lap_lrd",
    title: "LAP & LRD",
    icon: "Building2",
    blurb:
      "Unlock value from owned property or rental cash-flows with the right structure.",
    items: ["Loan Against Property", "Lease Rental Discounting"],
    image:
      "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=940&q=80",
  },
  {
    id: "project_finance",
    title: "Project Finance",
    icon: "HardHat",
    blurb:
      "From IT parks to factories — we structure debt that scales with your project.",
    items: ["IT Parks", "Factories", "Commercial Construction"],
    image:
      "https://images.unsplash.com/photo-1599707254554-027aeb4deacd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwcHJvamVjdCUyMGZpbmFuY2V8ZW58MHx8fHwxNzc3NzM3NTMwfDA&ixlib=rb-4.1.0&q=85",
  },
];

export const REFERRAL_LIST = [
  "Business owner buying commercial property",
  "Manufacturer needing working capital",
  "Doctor or CA setting up a clinic / office",
  "Auto or FMCG distributor / dealer",
  "PG owner or rental property investor",
  "IT park or commercial building owner",
  "Salaried — home or personal loan",
  "Anyone wanting an EMI balance transfer",
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Discovery Call",
    desc: "A 20-minute conversation to understand your goal, numbers and timeline — no jargon, no pitch.",
  },
  {
    n: "02",
    title: "Lender Match",
    desc: "We map you to 2-3 best-fit lenders from our 15+ partner network based on profile and pricing.",
  },
  {
    n: "03",
    title: "Document Pack",
    desc: "A single shared checklist. We chase paperwork so you don't — and pre-vet before submission.",
  },
  {
    n: "04",
    title: "Approval & Sanction",
    desc: "Targeted 48-hour approvals on eligible business loans*. Negotiated rates, transparent fees.",
  },
  {
    n: "05",
    title: "Disbursal & Beyond",
    desc: "We stay your point of contact post-disbursal — for top-ups, transfers and the next milestone.",
  },
];

export const PROFILES = [
  {
    title: "Salaried Professionals",
    desc: "Home, personal and balance-transfer loans tailored to your eligibility ladder.",
    icon: "BadgeCheck",
  },
  {
    title: "Self-Employed & Business Owners",
    desc: "Working capital, term loans, machinery and MSME funding with cash-flow-friendly structuring.",
    icon: "Briefcase",
  },
  {
    title: "Property Investors",
    desc: "LAP, LRD and project finance for IT parks, PGs, commercial buildings and rental portfolios.",
    icon: "Building2",
  },
];
